import { POLICY_UPDATED } from '../constants/site';
import CtaBand from './CtaBand';
import Layout, { PageHero } from './Layout';

export default function PolicyLayout({ title, intro, children }) {
  return (
    <Layout>
      <PageHero eyebrow="Legal" title={title} lead={intro} crumbs={[{ label: title }]} />
      <section className="section">
        <div className="container container--narrow">
          <p className="policy-updated">Last updated: {POLICY_UPDATED}</p>
          <article className="prose policy">{children}</article>
        </div>
      </section>
      <CtaBand title="Questions about this policy?" text="Ask us in live chat and a member of our team will explain any part of it." />
    </Layout>
  );
}
